<template>
    <div>
        <sweet-modal :title="$t('modal_settings_addClasification')" blocking ref="createClassificationModal"  class="modal" v-on:close="closeModal">
            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-form-item v-if="value" prop="name">
                    <el-input :value="value" @input="(val) => $emit('input', val)" :placeholder="$t('modal_settings_classificationName')"></el-input>
                </el-form-item>
                <el-form-item v-else prop="name">
                    <el-input :placeholder="$t('modal_settings_classificationName')" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="addItem('form')" class="modal__btn" type="primary" plain size="small">{{$t('modal_settings_addClasification')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
    </div>
</template>
<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  export default{
    name: 'create-classification',
    props: ['value'],
    components:{
      SweetModal,

    },
    data(){
      return {
        form:{
          name: ''
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods:{
      openModal(){
        this.$refs.createClassificationModal.open()
      },
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              name: this.form.name
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companyClassifications/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.notification(this.$t('modal_settings_success'), this.$t('modal_settings_addClasification'), "success");
                // this.loadList(this.state)
                if(this.$route.name === 'settings'){
                  this.$emit('loadList', 'companyClassifications')
                }else if(this.$route.name === 'settings' && this.value){
                  let newClassification = {
                    name: this.value || this.form.name,
                    id: response.data.companyClassificationId
                  }
                  console.log('newCategory', newClassification)
                  this.$emit('setNewClassification', newClassification)
                }
                this.$refs.createClassificationModal.close()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closeModal(){
        // this.form.no = ''
        this.form.name = ''
        this.$refs['form'].resetFields();
      },
    }
  }
</script>
